import { useCallback, useMemo } from 'react';

import { useRequestGatewayContext } from '../context/useRequestGatewayContext';
import { useTokensStore } from '../stores/useTokensStore';

export const useRequestGateway = () => {
  const { isProtectedRoute, baseUrl, refreshTokenUrl, source } =
    useRequestGatewayContext();
  const accessToken = useTokensStore((state) => state.accessToken);
  const refreshToken = useTokensStore((state) => state.refreshToken);
  const accessTokenExpiration = useTokensStore(
    (state) => state.accessTokenExpiration
  );
  const clearTokensFromStore = useTokensStore((state) => state.clear);
  const saveTokens = useTokensStore((state) => state.saveTokens);

  const getAuthenticatedState = useCallback(() => {
    const isTokenValid =
      accessToken &&
      accessTokenExpiration &&
      accessTokenExpiration > Date.now();

    if (!isTokenValid) {
      clearTokensFromStore();
    }

    return isTokenValid;
  }, [accessToken, accessTokenExpiration, clearTokensFromStore]);

  const writeTokens = useCallback(
    ({
      accessToken,
      accessTokenExpiration,
      refreshToken,
      refreshTokenExpiration,
    }: {
      accessToken: string;
      accessTokenExpiration: number;
      refreshToken: string;
      refreshTokenExpiration: number;
    }) => {
      saveTokens({
        accessToken,
        accessTokenExpiration,
        refreshToken,
        refreshTokenExpiration,
      });
    },
    [saveTokens]
  );

  return useMemo(
    () => ({
      refreshTokenUrl,
      refreshToken,
      getAuthenticatedState,
      isProtectedRoute,
      baseUrl,
      clearTokens: clearTokensFromStore,
      isTokenSet: !!accessToken,
      writeTokens,
      source,
    }),
    [
      baseUrl,
      refreshTokenUrl,
      refreshToken,
      clearTokensFromStore,
      getAuthenticatedState,
      isProtectedRoute,
      accessToken,
      writeTokens,
      source,
    ]
  );
};
